import CheckIcon from '@mui/icons-material/Check';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import {
  Button,
  Grid,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Container, Stack } from '@mui/system';
import React, { useEffect, useState } from 'react';
import Countdown from 'react-countdown';
import Carousel from 'react-material-ui-carousel';

import InformationSubMenu from '@/components/nav/InformationSubMenu';
import ExitPopup1098s from '@/components/ui/ExitPopup1098s';
import PricingDetailsInfoACA from '@/components/ui/PricingDetailsInfoACA';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
import { getLastDateOfTheMonth } from '@/utils/utils';

const Form1098Series = () => {
  // const [hoveredImageIndex, setHoveredImageIndex] = useState<string | null>(
  //   null
  // );

  // const handleMouseOver = (id: string) => {
  //   setHoveredImageIndex(id);
  // };

  // const handleMouseOut = () => {
  //   setHoveredImageIndex(null);
  // };
  const DEFAULT_ACTIVE_ID = 'f1098-who-file-img';

  const [hoveredImageIndex, setHoveredImageIndex] =
    useState<string>(DEFAULT_ACTIVE_ID);

  const [previousHoveredId, setPreviousHoveredId] =
    useState<string>(DEFAULT_ACTIVE_ID);

  const handleMouseOver = (id: string) => {
    setPreviousHoveredId(hoveredImageIndex);
    setHoveredImageIndex(id);
  };

  const handleMouseOut = () => {
    setHoveredImageIndex(previousHoveredId);
  };
  const getOpacity = (id: string) => (hoveredImageIndex === id ? 1 : 0.5);

  const [isPriceView1098s, setIsPriceView1098s] = React.useState(false);
  const images = [
    {
      label: (
        <React.Fragment>
          TaxZerone made filing my 1098 Forms super easy. The process was
          simple, and I got everything filed with the IRS in minutes. Highly
          recommend for smooth filing!
          <Stack
            direction="row"
            spacing={1}
            sx={{ mt: 2 }}
            justifyContent={{ xs: 'center', md: 'center' }}
          >
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-1"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-2"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-3"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-4"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-5"
            />
          </Stack>
          <Typography
            variant="body1"
            sx={{ mt: 2, textAlign: 'right', fontWeight: 600 }}
          >
            - Harper Lewis
          </Typography>
        </React.Fragment>
      ),
    },
    {
      label: (
        <React.Fragment>
          Filing 1098 Forms through TaxZerone was quick, simple, and way more
          affordable than other services I’ve tried. A great platform for
          information returns.
          <Stack
            direction="row"
            spacing={1}
            sx={{ mt: 2 }}
            justifyContent={{ xs: 'center', md: 'center' }}
          >
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-1"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-2"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-3"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-4"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-5"
            />
          </Stack>
          <Typography
            variant="body1"
            sx={{ mt: 2, textAlign: 'right', fontWeight: 600 }}
          >
            - Jackson Hayes
          </Typography>
        </React.Fragment>
      ),
    },
    {
      label: (
        <React.Fragment>
          TaxZerone is perfect for 1098 Form filing. The instructions were
          clear, and their customer support guided me through every step. I’ll
          definitely use it again next year!
          <Stack
            direction="row"
            spacing={1}
            sx={{ mt: 2 }}
            justifyContent={{ xs: 'center', md: 'center' }}
          >
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-1"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-2"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-3"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-4"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-5"
            />
          </Stack>
          <Typography
            variant="body1"
            sx={{ mt: 2, textAlign: 'right', fontWeight: 600 }}
          >
            - Madison Taylor
          </Typography>
        </React.Fragment>
      ),
    },
  ];
  const [lastDayTaxSeason, setLastDayTaxSeason] = useState(new Date());

  useEffect(() => {
    setLastDayTaxSeason(getLastDateOfTheMonth(new Date().getFullYear(), 3, 31));
    setInterval(() => {
      setLastDayTaxSeason(
        getLastDateOfTheMonth(new Date().getFullYear(), 3, 31)
      );
    }, 1000); // Updates every second (adjust if needed)
  }, []);

  // Random component
  const Completionist = () => <span />;

  // Renderer callback with condition
  const renderer = ({
    days,
    hours,
    minutes,
    seconds,
    completed,
  }: {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
    completed: boolean;
  }) => {
    if (completed) {
      // Render a completed state
      return <Completionist />;
    }
    // Render a countdown
    return (
      <Stack
        direction="row"
        justifyContent={{ xs: 'center', md: 'flex-start' }}
        alignItems="center"
        spacing={1}
        sx={{
          '& .timer-count': {
            border: '1px solid #848484',
            p: 1.5,
            textAlign: 'center',
            minWidth: { xs: 55, sm: 70, md: 70 },
            position: 'relative',
            borderRadius: 2,
            boxShadow: ' 0 0 20px rgba(0,0,0,.12)',
          },
          '& .timer-number': {
            fontSize: { xs: 18, sm: 24 },
            fontWeight: 900,
          },
          '& .colon': {
            fontSize: { xs: 18, sm: 24 },
            px: { xs: 0.2, sm: 0.5 },
            py: 0,
            mt: { xs: '-8px !important', sm: '-14px !important' },
          },
          '& .timer-label': {
            background: '#000',
            borderTop: '1px solid #848484',
            fontSize: { xs: 10, sm: 12 },
            fontWeight: 500,
            mt: 0,
            mx: -1.5,
            mb: -1.5,
            py: 0.2,
            px: { xs: 0.5, sm: 1, lg: 0.5 },
            borderRadius: '0px 0px 8px 8px',
          },
        }}
      >
        <Box className="timer-count">
          <Box className="timer-number">
            {days?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Days</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {hours?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Hours</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {minutes?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Minutes</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {seconds?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Seconds</Box>
        </Box>
      </Stack>
    );
  };
  return (
    <AppLayout
      meta={
        <Meta
          title="E-File IRS 1098 Forms Online Quickly with TaxZerone"
          description="E-File IRS Form 1098 Series (1098, 1098-T, 1098-E, and more) online with TaxZerone. Simple, secure, and affordable pricing with instant IRS filing confirmation."
          keywords=""
          canonical="form-1098-series/"
          jsonLdPricing="2.49"
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="2183"
          ogShareImg="assets/images/information-share-img.png"
        />
      }
    >
      <ExitPopup1098s
        isPriceView1098s={isPriceView1098s}
        setIsPriceView1098s={setIsPriceView1098s}
      />
      <InformationSubMenu />
      <Container
        sx={{
          position: 'relative',
          mt: 2,
          mb: 0,
        }}
        maxWidth="lg"
      >
        <Box
          sx={{
            background:
              'linear-gradient(275deg,rgba(79, 69, 27, 1) 0%, rgba(48, 35, 102, 1) 100%)',
            p: 1.5,
            px: 2.5,
            color: '#fff',
          }}
          className="ribbon"
        >
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 1, sm: 2 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Box>
              <Typography
                component="div"
                variant="body1"
                sx={{
                  textAlign: { xs: 'center', sm: 'left' },
                  fontSize: { xs: 15, sm: 17, md: 18, lg: '1.20rem' },
                  color: '#ccc',
                  lineHeight: 1.3,
                }}
              >
                <strong>📢 Deadline Has Passed!</strong> E-File Your 2025{' '}
                <b style={{ fontWeight: 600, color: '#efd6ac' }}>
                  Form 1098 Series
                </b>{' '}
                Today to Stay IRS-Compliant and Avoid Penalties.
              </Typography>
            </Box>
            <Box>
              {/* <Typography
                variant="body2"
                sx={{
                  textAlign: 'center',
                  mb: { xs: 1, sm: 1 },
                  lineHeight: 1.3,
                }}
              >
                Time left to file before the deadline{' '}
                <Hidden smUp>
                  <br />
                </Hidden>
                (
                <span style={{ fontWeight: 600, color: '#fff' }}>
                  Feb 02, 2026
                </span>
                ):
              </Typography> */}
              <Countdown date={lastDayTaxSeason} renderer={renderer} />
            </Box>
            <Box>
              <Button
                variant="contained"
                size="small"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=acatax`}
                sx={{
                  backgroundColor: '#fff',
                  '&:hover, &:focus': {
                    backgroundColor: '#213e99',
                    color: '#fff',
                  },
                  px: 2,
                  color: '#333',
                  mt: { xs: 0, md: 0 },
                  display: { xs: 'inline-block', sm: 'inline-block' },
                  mx: { xs: 'auto', sm: 1 },
                  borderRadius: 3,
                  boxShadow: 'none',
                  fontSize: { xs: 14, sm: 16, md: 18 },
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                }}
              >
                E-File Now
              </Button>
            </Box>
          </Stack>
        </Box>
      </Container>

      <Box sx={{ maxWidth: 1920, mx: 'auto' }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                E-File{' '}
                <span className="highlight-container">
                  <span className="highlight">Form 1098 Series</span>
                </span>{' '}
                for the 2025 Tax Year
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  mb: 2,
                }}
              >
                If you are a lender, financial institution, or educational
                organization, filing your{' '}
                <span style={{ fontWeight: 600 }}> Form 1098 series</span> with
                TaxZerone is simple and accurate.
              </Typography>

              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Button
                  variant="contained"
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1098forms`}
                  sx={{
                    mr: { xs: 0, md: 4 },
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                >
                  Get Started Now
                </Button>
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent={{
                    xs: 'center',
                    md: 'flex-start',
                  }}
                  alignItems="center"
                >
                  <Box
                    sx={{
                      mb: { xs: '0 !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/irs-authorized.webp" />
                      <source srcSet="/assets/images/irs-authorized.png" />
                      <Box
                        component="img"
                        src="/assets/images/irs-authorized.png"
                        loading="lazy"
                        alt="IRS-authorized e-file provider"
                        width={70}
                        height={69}
                        sx={{
                          width: { xs: 50, md: 70 },
                          height: { xs: 49, md: 69 },
                        }}
                      />
                    </picture>
                  </Box>
                  <Box
                    sx={{
                      mb: { xs: '0px !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/tzo-soc2.webp" />
                      <source srcSet="/assets/images/tzo-soc2.png" />
                      <Box
                        component="img"
                        src="/assets/images/tzo-soc2.png"
                        loading="lazy"
                        alt="TZO SOC2 Compliant"
                        width={90}
                        height={89}
                        sx={{
                          width: { xs: 70, md: 90 },
                          height: { xs: 69, md: 89 },
                        }}
                      />
                    </picture>
                  </Box>
                </Stack>
              </Stack>

              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={0}
                m={0}
                mt={{ xs: 2, md: 5 }}
                pb={0}
                textAlign="center"
                sx={{ ml: { xs: 0, md: -5 } }}
              >
                <Grid size={{ xs: 4, sm: 4, md: 4 }}>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 4,
                      borderWidth: 0,
                      fontSize: { xs: 9, sm: 12, lg: 13 },
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: '#efefef',
                        borderRadius: '50%',
                        width: { xs: 40, sm: 70 },
                        height: { xs: 40, sm: 70 },
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        mx: 'auto',
                        mb: { xs: 0.5, sm: 1 },
                        p: { xs: 1, sm: 2 },
                        textAlign: 'center',
                      }}
                    >
                      <picture style={{ width: '100%', height: '100%' }}>
                        <source
                          srcSet="/assets/images/secure-new-icon.webp"
                          width="100%"
                          height="100%"
                        />
                        <source
                          srcSet="/assets/images/secure-new-icon.png"
                          width="100%"
                          height="100%"
                        />
                        <img
                          src="/assets/images/secure-new-icon.png"
                          alt="Safe & Secure"
                          loading="lazy"
                          width="100%"
                          height="100%"
                        />
                      </picture>
                    </Box>
                    <strong>
                      Safe &
                      <Hidden lgUp mdDown>
                        <br />
                      </Hidden>{' '}
                      Secure
                    </strong>
                  </Paper>
                </Grid>
                <Grid size={{ xs: 4, sm: 4, md: 4 }}>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 4,
                      borderWidth: 0,
                      fontSize: { xs: 9, sm: 12, lg: 13 },
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: '#efefef',
                        borderRadius: '50%',
                        width: { xs: 40, sm: 70 },
                        height: { xs: 40, sm: 70 },
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        mx: 'auto',
                        mb: { xs: 0.5, sm: 1 },
                        p: { xs: 1, sm: 2 },
                        textAlign: 'center',
                      }}
                    >
                      <picture style={{ width: '100%', height: '100%' }}>
                        <source
                          srcSet="/assets/images/irs-new-icon.webp"
                          width="100%"
                          height="100%"
                        />
                        <source
                          srcSet="/assets/images/irs-new-icon.png"
                          width="100%"
                          height="100%"
                        />
                        <img
                          src="/assets/images/irs-new-icon.png"
                          alt="IRS Authorized"
                          loading="lazy"
                          width="100%"
                          height="100%"
                        />
                      </picture>
                    </Box>
                    <strong>
                      IRS
                      <Hidden lgUp mdDown>
                        <br />
                      </Hidden>{' '}
                      Authorized
                    </strong>
                  </Paper>
                </Grid>
                <Grid size={{ xs: 4, sm: 4, md: 4 }}>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 1, sm: 2 },
                      borderRadius: 0,
                      borderWidth: 0,
                      fontSize: { xs: 9, sm: 12, lg: 13 },
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: '#efefef',
                        borderRadius: '50%',
                        width: { xs: 40, sm: 70 },
                        height: { xs: 40, sm: 70 },
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        mx: 'auto',
                        mb: { xs: 0.5, sm: 1 },
                        p: { xs: 1, sm: 2 },
                        textAlign: 'center',
                      }}
                    >
                      <picture style={{ width: '100%', height: '100%' }}>
                        <source
                          srcSet="/assets/images/lowest-new-icon.webp"
                          width="100%"
                          height="100%"
                        />
                        <source
                          srcSet="/assets/images/lowest-new-icon.png"
                          width="100%"
                          height="100%"
                        />
                        <img
                          src="/assets/images/lowest-new-icon.png"
                          alt="Affordable Price"
                          loading="lazy"
                          width="100%"
                          height="100%"
                        />
                      </picture>
                    </Box>
                    <strong>
                      Affordable
                      <Hidden lgUp mdDown>
                        <br />
                      </Hidden>{' '}
                      Filing Fee
                    </strong>
                  </Paper>
                </Grid>
              </Grid>
            </Box>
          </Box>
          <Hidden lgDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
              className="form-1098s-tax"
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/f1098s-landing-img.webp"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
                <source
                  srcSet="/assets/images/f1098s-landing-img.png"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
                <img
                  src="/assets/images/f1098s-landing-img.png"
                  alt="E-File Form 1098 Series for the 2025 Tax Year"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>
          <Hidden lgUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
              className="form-1098s-tax"
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/f1098s-landing-img-sm-sm.webp"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <source
                  srcSet="/assets/images/f1098s-landing-img-sm-img-sm.png"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <img
                  src="/assets/images/f1098s-landing-img-sm-sm.png"
                  alt="E-File Form 1098 Series for the 2025 Tax Year"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 3 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <PricingDetailsInfoACA
                formName="1098 Forms"
                colorCode="#4269e2"
              />{' '}
              <Typography variant="body1" sx={{ mb: 2, textAlign: 'right' }}>
                <Link
                  sx={{ color: '#0202ff', cursor: 'pointer' }}
                  onClick={() => setIsPriceView1098s(true)}
                >
                  How TaxZerone’s Pricing Works?
                </Link>
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          mb: 4,
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 3 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                Pricing Includes
              </Typography>
            </Grid>
            <Grid
              size={{ xs: 12, md: 5, sm: 4 }}
              textAlign="center"
              sx={{
                display: 'flex',
                alignSelf: 'end',
                alignItems: 'flex-end',
                placeContent: { sm: 'end', xs: 'center' },
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  backgroundColor: '#f0f2f9',
                  p: 2,
                  borderRadius: 3,
                  minHeight: '100%',

                  textAlign: 'left',

                  maxWidth: 400,
                }}
              >
                <Stack spacing={1} direction="column">
                  <Box
                    sx={{
                      display: 'grid',
                      columnGap: 1,
                      gridTemplateColumns: 'auto auto ',
                      textAlign: 'left',
                      placeContent: 'start',
                    }}
                  >
                    <Box>
                      <CheckIcon sx={{ color: '#1da94a' }} />
                    </Box>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Bulk Filing{' '}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'grid',
                      columnGap: 1,
                      gridTemplateColumns: 'auto auto ',
                      textAlign: 'left',
                      placeContent: 'start',
                    }}
                  >
                    <Box>
                      <CheckIcon sx={{ color: '#1da94a' }} />
                    </Box>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Schedule Filing
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'grid',
                      columnGap: 1,
                      gridTemplateColumns: 'auto auto ',
                      textAlign: 'left',
                      placeContent: 'start',
                    }}
                  >
                    <Box>
                      <CheckIcon sx={{ color: '#1da94a' }} />
                    </Box>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Transmittal Form 1096
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'grid',
                      columnGap: 1,
                      gridTemplateColumns: 'auto auto ',
                      textAlign: 'left',
                      placeContent: 'start',
                    }}
                  >
                    <Box>
                      <CheckIcon sx={{ color: '#1da94a' }} />
                    </Box>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      USPS Address Validation
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'grid',
                      columnGap: 1,
                      gridTemplateColumns: 'auto auto ',
                      textAlign: 'left',
                      placeContent: 'start',
                    }}
                  >
                    <Box>
                      <CheckIcon sx={{ color: '#1da94a' }} />
                    </Box>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Error Checks
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'grid',
                      columnGap: 1,
                      gridTemplateColumns: 'auto auto ',
                      textAlign: 'left',
                      placeContent: 'start',
                    }}
                  >
                    <Box>
                      <CheckIcon sx={{ color: '#1da94a' }} />
                    </Box>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Expert Support
                    </Typography>
                  </Box>
                </Stack>
              </Paper>
            </Grid>

            <Grid
              size={{ xs: 12, md: 7, sm: 8 }}
              sx={{
                mt: 0,
                textAlign: 'center',
                justifyContent: 'center',
                alignSelf: 'start',
              }}
            >
              <Typography
                variant="h3"
                sx={{
                  fontSize: { md: 22, sm: 20, xs: 18 },
                  textAlign: 'center',
                  fontWeight: 600,
                  mt: 0,
                  mb: 1,
                }}
              >
                Add-ons Available{' '}
              </Typography>
              <Box sx={{ mb: 5, maxWidth: 600, m: 'auto' }}>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 1 }}
                >
                  <Table aria-label="EFW Individual">
                    <TableHead>
                      {/* <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                          }}
                        >
                          Aspect
                        </TableCell>
                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                          }}
                        >
                          IRP (International Registration Plan)
                        </TableCell>
                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                          }}
                        >
                          IFTA (International Fuel Tax Agreement)
                        </TableCell>
                      </TableRow> */}
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 600 }}>
                          Electronic Delivery
                        </TableCell>
                        <TableCell>
                          <span
                            style={{
                              fontWeight: 700,
                              color: '#4269e2',
                              fontSize: 20,
                            }}
                          >
                            $ 0.50
                          </span>
                          /form
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                        <TableCell sx={{ fontWeight: 600 }}>
                          Postal Mailing
                        </TableCell>
                        <TableCell>
                          <span
                            style={{
                              fontWeight: 700,
                              color: '#4269e2',
                              fontSize: 20,
                            }}
                          >
                            $1.75
                          </span>
                          /form
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: { md: 8, sm: 4, xs: 3 } }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                E-File Form 1098 Series Quickly and Accurately with TaxZerone
              </Typography>
            </Grid>
            <Grid
              size={{ xs: 12, md: 4, sm: 6 }}
              textAlign="right"
              sx={{
                rowGap: 1,
                position: 'relative',
                // maxWidth: '450px',
                display: 'flex',
                justifyContent: 'right',
                m: 'auto',
                alignContent: 'right',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  borderRadius: 3,
                  minHeight: '100%',
                  position: 'relative',
                  maxWidth: '363px',
                  borderWidth: 2,
                  transition: 'all 0.5s ease 0s',
                  '&:hover, &:focus, &:active': {
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.12)',
                    borderColor: '#989898',
                  },
                  '&:hover h3': { color: '#4269e2' },
                  '&:hover .MuiTypography-body2 ': {
                    backgroundColor: '#faedcd',
                  },
                }}
              >
                {' '}
                <Link
                  href="/information-returns/efile-irs-form-1098/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Box
                    sx={{
                      textAlign: 'center',
                      mb: 0,
                      borderTopRightRadius: 16,
                      borderTopLeftRadius: 12,
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/f1098-mortgage-img.webp" />
                      <source srcSet="/assets/images/f1098-mortgage-img.png" />
                      <img
                        src="/assets/images/f1098-mortgage-img.png"
                        alt="Mortgage Interest Statement"
                        className="partner-card"
                        loading="lazy"
                        width={360}
                        height={310}
                        style={{
                          borderTopRightRadius: 12,
                          borderTopLeftRadius: 12,
                          // aspectRatio: 3 / 2,
                        }}
                      />
                    </picture>
                  </Box>
                  <Box sx={{ p: 2.8, textAlign: 'left', mb: 1 }}>
                    <Box
                      sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 1,
                        textAlign: 'left',
                        position: 'absolute',
                        top: 16,
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          p: 0,
                          backgroundColor: '#fff',
                          display: 'flex',
                          boxAlign: 'center',
                          alignItems: 'center',
                          borderRadius: 3,
                          fontWeight: 700,
                          color: '#0d1b2a',
                          px: 1,
                          py: 0.5,
                          textTransform: 'uppercase',
                        }}
                      >
                        Form 1098
                      </Typography>
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { md: 20, sm: 18, xs: 16 },
                        fontWeight: 600,
                        textAlign: 'left',
                        mb: 4,
                        mt: 1,
                        color: 'rgb(68, 68, 68)',
                      }}
                    >
                      Mortgage Interest Statement
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ color: 'rgb(68, 68, 68)', mb: 3 }}
                    >
                      Report $600 or more in mortgage interest paid by an
                      individual to a lender during the year.
                    </Typography>
                  </Box>
                </Link>
                <Box sx={{ textAlign: 'center', mb: 3 }}>
                  <Button
                    variant="contained"
                    sx={{
                      textAlign: 'center',
                      textTransform: 'none',
                      borderRadius: 4,
                      boxShadow: 'none',
                      px: 3,
                      fontSize: { xs: 16, sm: 18, md: 20 },
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': {
                        transform: 'scale(1.1)',
                        boxShadow: 'none',
                      },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1098forms`}
                  >
                    E-File 1098
                  </Button>
                </Box>
              </Paper>
            </Grid>

            <Grid
              size={{ xs: 12, md: 4, sm: 6 }}
              textAlign="left"
              sx={{
                rowGap: 1,
                position: 'relative',
                maxWidth: '450px',
                alignContent: 'right',
                display: 'flex',
                justifyContent: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  borderRadius: 3,
                  minHeight: '100%',
                  position: 'relative',
                  borderWidth: 2,
                  maxWidth: '363px',
                  transition: 'all 0.5s ease 0s',
                  '&:hover, &:focus, &:active': {
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.12)',
                    borderColor: '#989898',
                  },
                  '&:hover h3': { color: '#4269e2' },
                  '&:hover .MuiTypography-body2 ': {
                    backgroundColor: '#588157',
                    color: '#fff',
                  },
                }}
              >
                {' '}
                <Link
                  href="/information-returns/efile-irs-form-1098-c/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Box
                    sx={{
                      textAlign: 'center',
                      mb: 0,
                      borderTopRightRadius: 16,
                      borderTopLeftRadius: 12,
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/f1098c-contributions-img.webp" />
                      <source srcSet="/assets/images/f1098c-contributions-img.png" />
                      <img
                        src="/assets/images/f1098c-contributions-img.png"
                        alt="Contributions of Motor Vehicles, Boats, and Airplanes"
                        className="partner-card"
                        loading="lazy"
                        width={360}
                        height={310}
                        style={{
                          borderTopRightRadius: 12,
                          borderTopLeftRadius: 12,
                        }}
                      />
                    </picture>
                  </Box>
                  <Box sx={{ p: 2.8, textAlign: 'left', mb: 1 }}>
                    <Box
                      sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 1,
                        textAlign: 'left',
                        position: 'absolute',
                        top: 16,
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          p: 0,
                          backgroundColor: '#fff',
                          display: 'flex',
                          boxAlign: 'center',
                          alignItems: 'center',
                          borderRadius: 3,
                          fontWeight: 700,
                          color: '#0d1b2a',
                          px: 1,
                          py: 0.5,
                          // textTransform: 'uppercase',
                        }}
                      >
                        FORM 1098-C
                      </Typography>
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { md: 20, sm: 18, xs: 16 },
                        fontWeight: 600,
                        textAlign: 'left',
                        mb: 1,
                        mt: 1,
                        color: 'rgb(68, 68, 68)',
                      }}
                    >
                      Contributions of Motor Vehicles, Boats, and Airplanes
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ color: 'rgb(68, 68, 68)' }}
                    >
                      Report donations of motor vehicles, boats, or airplanes
                      valued at $500 or more made to a qualified charitable
                      organization.
                    </Typography>
                  </Box>
                </Link>
                <Box sx={{ textAlign: 'center', mb: 3 }}>
                  <Button
                    variant="contained"
                    sx={{
                      textAlign: 'center',
                      textTransform: 'none',
                      borderRadius: 4,
                      boxShadow: 'none',
                      px: 3,
                      fontSize: { xs: 16, sm: 18, md: 20 },
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': {
                        transform: 'scale(1.1)',
                        boxShadow: 'none',
                      },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1098forms`}
                  >
                    E-File 1098-C
                  </Button>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, md: 4, sm: 6 }}
              textAlign="left"
              sx={{
                rowGap: 1,
                position: 'relative',
                maxWidth: '450px',
                alignContent: 'right',
                display: 'flex',
                justifyContent: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  borderRadius: 3,
                  minHeight: '100%',
                  position: 'relative',
                  borderWidth: 2,
                  maxWidth: '363px',
                  transition: 'all 0.5s ease 0s',
                  '&:hover, &:focus, &:active': {
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.12)',
                    borderColor: '#989898',
                  },
                  '&:hover h3': { color: '#4269e2' },
                  '&:hover .MuiTypography-body2 ': {
                    backgroundColor: '#ca6702',
                    color: '#fff',
                  },
                }}
              >
                {' '}
                <Link
                  href="/information-returns/efile-irs-form-1098-e/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Box
                    sx={{
                      textAlign: 'center',
                      mb: 0,
                      borderTopRightRadius: 16,
                      borderTopLeftRadius: 12,
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/f1098e-student-loan-img.webp" />
                      <source srcSet="/assets/images/f1098e-student-loan-img.png" />
                      <img
                        src="/assets/images/f1098e-student-loan-img.png"
                        alt="Student Loan Interest Statement"
                        className="partner-card"
                        loading="lazy"
                        width={360}
                        height={310}
                        style={{
                          borderTopRightRadius: 12,
                          borderTopLeftRadius: 12,
                        }}
                      />
                    </picture>
                  </Box>
                  <Box sx={{ p: 2.8, textAlign: 'left', mb: 4 }}>
                    <Box
                      sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 1,
                        textAlign: 'left',
                        position: 'absolute',
                        top: 16,
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          p: 0,
                          backgroundColor: '#fff',
                          display: 'flex',
                          boxAlign: 'center',
                          alignItems: 'center',
                          borderRadius: 3,
                          fontWeight: 700,
                          color: '#0d1b2a',
                          px: 1,
                          py: 0.5,
                          // textTransform: 'uppercase',
                        }}
                      >
                        FORM 1098-E
                      </Typography>
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { md: 20, sm: 18, xs: 16 },
                        fontWeight: 600,
                        textAlign: 'left',
                        mb: 1,
                        mt: 1,
                        color: 'rgb(68, 68, 68)',
                      }}
                    >
                      Student Loan Interest Statement
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ color: 'rgb(68, 68, 68)' }}
                    >
                      Report $600 or more in student loan interest paid by a
                      borrower during the year.
                    </Typography>
                  </Box>
                </Link>
                <Box sx={{ textAlign: 'center', mb: 3 }}>
                  <Button
                    variant="contained"
                    sx={{
                      textAlign: 'center',
                      textTransform: 'none',
                      borderRadius: 4,
                      boxShadow: 'none',
                      px: 3,
                      fontSize: { xs: 16, sm: 18, md: 20 },
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': {
                        transform: 'scale(1.1)',
                        boxShadow: 'none',
                      },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1098forms`}
                  >
                    E-File 1098-E
                  </Button>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, md: 4, sm: 6 }}
              textAlign="left"
              sx={{
                rowGap: 1,
                position: 'relative',
                maxWidth: '450px',
                alignContent: 'right',
                display: 'flex',
                justifyContent: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  borderRadius: 3,
                  minHeight: '100%',
                  position: 'relative',
                  borderWidth: 2,
                  maxWidth: '363px',
                  transition: 'all 0.5s ease 0s',
                  '&:hover, &:focus, &:active': {
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.12)',
                    borderColor: '#989898',
                  },
                  '&:hover h3': { color: '#4269e2' },
                  '&:hover .MuiTypography-body2 ': {
                    backgroundColor: '#023e8a',
                    color: '#fff',
                  },
                }}
              >
                {' '}
                <Link
                  href="/information-returns/efile-irs-form-1098-f/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Box
                    sx={{
                      textAlign: 'center',
                      mb: 0,
                      borderTopRightRadius: 16,
                      borderTopLeftRadius: 12,
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/f1098f-fines-penalties-img.webp" />
                      <source srcSet="/assets/images/f1098f-fines-penalties-img.png" />
                      <img
                        src="/assets/images/f1098f-fines-penalties-img.png"
                        alt="Fines, Penalties, and Other Amounts"
                        className="partner-card"
                        loading="lazy"
                        width={360}
                        height={310}
                        style={{
                          borderTopRightRadius: 12,
                          borderTopLeftRadius: 12,
                        }}
                      />
                    </picture>
                  </Box>
                  <Box sx={{ p: 2.8, textAlign: 'left', mb: 1 }}>
                    <Box
                      sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 1,
                        textAlign: 'left',
                        position: 'absolute',
                        top: 16,
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          p: 0,
                          backgroundColor: '#fff',
                          display: 'flex',
                          boxAlign: 'center',
                          alignItems: 'center',
                          borderRadius: 3,
                          fontWeight: 700,
                          color: '#0d1b2a',
                          px: 1,
                          py: 0.5,
                          // textTransform: 'uppercase',
                        }}
                      >
                        FORM 1098-F
                      </Typography>
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { md: 20, sm: 18, xs: 16 },
                        fontWeight: 600,
                        textAlign: 'left',
                        mb: 1,
                        mt: 1,
                        color: 'rgb(68, 68, 68)',
                      }}
                    >
                      Fines, Penalties, and Other Amounts
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ color: 'rgb(68, 68, 68)' }}
                    >
                      Reports fines, penalties, and other amounts paid to
                      government entities for legal violations for taxpayers
                      paying $50,000 or more.
                    </Typography>
                  </Box>
                </Link>
                <Box sx={{ textAlign: 'center', mb: 3 }}>
                  <Button
                    variant="contained"
                    sx={{
                      textAlign: 'center',
                      textTransform: 'none',
                      borderRadius: 4,
                      boxShadow: 'none',
                      px: 3,
                      fontSize: { xs: 16, sm: 18, md: 20 },
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': {
                        transform: 'scale(1.1)',
                        boxShadow: 'none',
                      },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1098forms`}
                  >
                    E-File 1098-F
                  </Button>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, md: 4, sm: 6 }}
              textAlign="left"
              sx={{
                rowGap: 1,
                position: 'relative',
                maxWidth: '450px',
                alignContent: 'right',
                display: 'flex',
                justifyContent: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  borderRadius: 3,
                  minHeight: '100%',
                  position: 'relative',
                  borderWidth: 2,
                  maxWidth: '363px',
                  transition: 'all 0.5s ease 0s',
                  '&:hover, &:focus, &:active': {
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.12)',
                    borderColor: '#989898',
                  },
                  '&:hover h3': { color: '#4269e2' },
                  '&:hover .MuiTypography-body2 ': {
                    backgroundColor: '#005f73',
                    color: '#fff',
                  },
                }}
              >
                {' '}
                <Link
                  href="/information-returns/efile-irs-form-1098-t/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Box
                    sx={{
                      textAlign: 'center',
                      mb: 0,
                      borderTopRightRadius: 16,
                      borderTopLeftRadius: 12,
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/f1098t-tuition-img.webp" />
                      <source srcSet="/assets/images/f1098t-tuition-img.png" />
                      <img
                        src="/assets/images/f1098t-tuition-img.png"
                        alt="Tuition Statement "
                        className="partner-card"
                        loading="lazy"
                        width={360}
                        height={310}
                        style={{
                          borderTopRightRadius: 12,
                          borderTopLeftRadius: 12,
                        }}
                      />
                    </picture>
                  </Box>
                  <Box sx={{ p: 2.8, textAlign: 'left', mb: 4.5 }}>
                    <Box
                      sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 1,
                        textAlign: 'left',
                        position: 'absolute',
                        top: 16,
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          p: 0,
                          backgroundColor: '#fff',
                          display: 'flex',
                          boxAlign: 'center',
                          alignItems: 'center',
                          borderRadius: 3,
                          fontWeight: 700,
                          color: '#0d1b2a',
                          px: 1,
                          py: 0.5,
                          // textTransform: 'uppercase',
                        }}
                      >
                        FORM 1098-T
                      </Typography>
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { md: 20, sm: 18, xs: 16 },
                        fontWeight: 600,
                        textAlign: 'left',
                        mb: 3,
                        mt: 1,
                        color: 'rgb(68, 68, 68)',
                      }}
                    >
                      Tuition Statement
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ color: 'rgb(68, 68, 68)' }}
                    >
                      Report qualified tuition and related educational expenses
                      billed by eligible educational institutions to students.
                    </Typography>
                  </Box>
                </Link>
                <Box sx={{ textAlign: 'center', mb: 3 }}>
                  <Button
                    variant="contained"
                    sx={{
                      textAlign: 'center',
                      textTransform: 'none',
                      borderRadius: 4,
                      boxShadow: 'none',
                      px: 3,
                      fontSize: { xs: 16, sm: 18, md: 20 },
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': {
                        transform: 'scale(1.1)',
                        boxShadow: 'none',
                      },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1098forms`}
                  >
                    E-File 1098-T
                  </Button>
                </Box>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, md: 4, sm: 6 }}
              textAlign="left"
              sx={{
                rowGap: 1,
                position: 'relative',
                maxWidth: '450px',
                alignContent: 'right',
                display: 'flex',
                justifyContent: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  borderRadius: 3,
                  minHeight: '100%',
                  position: 'relative',
                  borderWidth: 2,
                  maxWidth: '363px',
                  transition: 'all 0.5s ease 0s',
                  '&:hover, &:focus, &:active': {
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.12)',
                    borderColor: '#989898',
                  },
                  '&:hover h3': { color: '#4269e2' },
                  '&:hover .MuiTypography-body2 ': {
                    backgroundColor: '#6f1d1b',
                    color: '#fff',
                  },
                }}
              >
                {' '}
                <Link
                  href="/information-returns/efile-irs-form-1098-q/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Box
                    sx={{
                      textAlign: 'center',
                      mb: 0,
                      borderTopRightRadius: 16,
                      borderTopLeftRadius: 12,
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/f1098q-qualifying-longevity-img.webp" />
                      <source srcSet="/assets/images/f1098q-qualifying-longevity-img.png" />
                      <img
                        src="/assets/images/f1098q-qualifying-longevity-img.png"
                        alt="Qualifying Longevity Annuity Contract Information"
                        className="partner-card"
                        loading="lazy"
                        width={360}
                        height={310}
                        style={{
                          borderTopRightRadius: 12,
                          borderTopLeftRadius: 12,
                        }}
                      />
                    </picture>
                  </Box>
                  <Box sx={{ p: 2.8, textAlign: 'left', mb: 4 }}>
                    <Box
                      sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 1,
                        textAlign: 'left',
                        position: 'absolute',
                        top: 16,
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          p: 0,
                          backgroundColor: '#fff',
                          display: 'flex',
                          boxAlign: 'center',
                          alignItems: 'center',
                          borderRadius: 3,
                          fontWeight: 700,
                          color: '#0d1b2a',
                          px: 1,
                          py: 0.5,
                          // textTransform: 'uppercase',
                        }}
                      >
                        FORM 1098-Q
                      </Typography>
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { md: 20, sm: 18, xs: 16 },
                        fontWeight: 600,
                        textAlign: 'left',
                        mb: 1,
                        mt: 1,
                        color: 'rgb(68, 68, 68)',
                      }}
                    >
                      Qualifying Longevity Annuity Contract Information
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ color: 'rgb(68, 68, 68)' }}
                    >
                      Report details about QLACs purchased from qualified
                      retirement accounts, such as IRAs and 401(k) plans.
                    </Typography>
                  </Box>
                </Link>
                <Box sx={{ textAlign: 'center', mb: 3 }}>
                  <Button
                    variant="contained"
                    sx={{
                      textAlign: 'center',
                      textTransform: 'none',
                      borderRadius: 4,
                      boxShadow: 'none',
                      px: 3,
                      fontSize: { xs: 16, sm: 18, md: 20 },
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': {
                        transform: 'scale(1.1)',
                        boxShadow: 'none',
                      },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1098forms`}
                  >
                    E-File 1098-Q
                  </Button>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            // direction={{ xs: 'column-reverse', sm: 'row' }}
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  width: '100%',
                  // mt: { xs: -3, md: -5, lg: -8 },
                }}
              >
                <img
                  src={
                    hoveredImageIndex !== null
                      ? `/assets/images/${hoveredImageIndex}.webp`
                      : '/assets/images/f1098-who-file-img.webp'
                  }
                  alt="Who Should File Form 1098s?"
                  className="img-responsive"
                  loading="lazy"
                  width={550}
                  height={500}
                  style={{ borderRadius: 21 }}
                />
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 1,
                  textAlign: 'center',
                }}
              >
                Who Should File Form 1098s?
              </Typography>

              <Box
                component="ul"
                sx={{
                  listStyleType: 'none',
                  paddingLeft: 0,
                  textAlign: 'left',
                  ml: { xs: 0, sm: 3 },
                  mt: { xs: 0, md: 3 },
                  mb: { xs: 0, md: 4 },
                  '& li': { display: 'flex' },
                }}
              >
                <Box
                  component="div"
                  onMouseEnter={() => handleMouseOver('f1098-who-file-img')}
                  onMouseLeave={handleMouseOut}
                  sx={{
                    cursor: 'pointer',
                    opacity: getOpacity('f1098-who-file-img'),
                    transition: 'opacity 0.2s ease-in-out',
                  }}
                >
                  <li style={{ marginBottom: 10 }}>
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />
                    <Box>
                      <span style={{ fontWeight: 600 }}>Form 1098</span>
                      <br />
                      Lenders, banks, mortgage companies, credit unions, and
                      other financial institutions
                    </Box>
                  </li>
                </Box>

                <Box
                  component="div"
                  onMouseEnter={() => handleMouseOver('f1098c-who-file-img')}
                  onMouseLeave={handleMouseOut}
                  sx={{
                    cursor: 'pointer',
                    opacity: getOpacity('f1098c-who-file-img'),
                    transition: 'opacity 0.2s ease-in-out',
                  }}
                >
                  <li style={{ marginBottom: 10 }}>
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />
                    <Box>
                      <span style={{ fontWeight: 600 }}>Form 1098-C</span>
                      <br />
                      Charitable organizations that receive a donation of a
                      motor vehicle, boat, or airplane.
                    </Box>
                  </li>
                </Box>

                <Box
                  component="div"
                  onMouseEnter={() => handleMouseOver('f1098e-who-file-img')}
                  onMouseLeave={handleMouseOut}
                  sx={{
                    cursor: 'pointer',
                    opacity: getOpacity('f1098e-who-file-img'),
                    transition: 'opacity 0.5s ease-in-out',
                  }}
                >
                  <li style={{ marginBottom: 10 }}>
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />
                    <Box>
                      <span style={{ fontWeight: 600 }}>Form 1098-E</span>
                      <br />
                      Financial institutions, government agencies, or
                      educational loan lenders
                    </Box>
                  </li>
                </Box>
                <Box
                  component="div"
                  onMouseEnter={() => handleMouseOver('f1098f-who-file-img')}
                  onMouseLeave={handleMouseOut}
                  sx={{
                    cursor: 'pointer',
                    opacity: getOpacity('f1098f-who-file-img'),
                    transition: 'opacity 0.5s ease-in-out',
                  }}
                >
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      <span style={{ fontWeight: 600 }}> Form 1098-F </span>{' '}
                      <br />
                      Governmental entities or agencies that have assessed and
                      collected fines, penalties, or other amounts
                    </Box>
                  </li>
                </Box>
                <Box
                  component="div"
                  onMouseEnter={() => handleMouseOver('f1098t-who-file-img')}
                  onMouseLeave={handleMouseOut}
                  sx={{
                    cursor: 'pointer',
                    opacity: getOpacity('f1098t-who-file-img'),
                    transition: 'opacity 0.5s ease-in-out',
                  }}
                >
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      <span style={{ fontWeight: 600 }}> Form 1098-T </span>{' '}
                      <br />
                      Eligible educational institutions (colleges, universities,
                      vocational schools)
                    </Box>
                  </li>
                </Box>
                <Box
                  component="div"
                  onMouseEnter={() => handleMouseOver('f1098q-who-file-img')}
                  onMouseLeave={handleMouseOut}
                  sx={{
                    cursor: 'pointer',
                    opacity: getOpacity('f1098q-who-file-img'),
                    transition: 'opacity 0.5s ease-in-out',
                  }}
                >
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      <span style={{ fontWeight: 600 }}> Form 1098-Q </span>{' '}
                      <br />
                      Insurance companies or plan administrators that issue or
                      maintain a Qualifying Longevity Annuity Contract (QLAC).
                    </Box>
                  </li>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction={{ xs: 'column-reverse', sm: 'row' }}
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 1,
                  textAlign: 'left',
                }}
              >
                Why File Form 1098s?
              </Typography>

              <Box
                component="ul"
                sx={{
                  listStyleType: 'none',
                  paddingLeft: 0,
                  textAlign: 'left',
                  ml: { xs: 0, sm: 3 },
                  mt: { xs: 0, md: 3 },
                  mb: { xs: 0, md: 3 },
                  '& li': { display: 'flex' },
                }}
              >
                {' '}
                <li
                  style={{
                    marginBottom: 10,
                  }}
                >
                  <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                  <Box>
                    By filing 1098 forms, institutions and organizations help
                    taxpayers to file their returns correctly and avoid IRS
                    issues.
                  </Box>
                </li>
                <li
                  style={{
                    marginBottom: 10,
                  }}
                >
                  <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                  <Box>
                    Filing Form 1098s helps taxpayers claim eligible deductions
                    and credits on their tax returns.
                  </Box>
                </li>
                <li
                  style={{
                    marginBottom: 10,
                  }}
                >
                  <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                  <Box>
                    Filing these forms provides official documentation of
                    payments received or contributions made.
                  </Box>
                </li>
                <li
                  style={{
                    marginBottom: 10,
                  }}
                >
                  <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                  <Box>
                    Filing will ensure transparency in financial transactions
                    like mortgage interest, tuition and donations.
                  </Box>
                </li>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }} sx={{ position: 'relative' }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                }}
              >
                <picture>
                  <source srcSet="/assets/images/f1098s-why-file-img.webp" />
                  <source srcSet="/assets/images/f1098s-why-file-img.png" />
                  <img
                    src="/assets/images/f1098s-why-file-img.png"
                    alt="Why File Form 1098s?"
                    className="img-responsive"
                    loading="lazy"
                    width={550}
                    height={500}
                    style={{ borderRadius: 21 }}
                  />
                </picture>
              </Box>
              {/* <Hidden mdDown>
                <Box
                  sx={{
                    position: 'absolute',
                    width: { lg: 240, md: 230 },
                    alignSelf: 'center',
                    maxWidth: '100%',
                    height: 80,
                    background: 'rgba(255, 255, 255, 0.06)',
                    backdropFilter: 'blur(16px)',
                    borderRadius: 4,
                    boxShadow:
                      '0 8px 32px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.5), inset 0 -1px 0 rgba(255, 255, 255, 0.1), inset 0 0 0px 0px rgba(255, 255, 255, 0)',
                    overflow: 'hidden',
                    top: { ld: 40, md: 0 },
                    right: { lg: 430, md: 290, sm: 360 },

                    '&:before': {
                      // content: '',
                      position: 'absolute',
                      top: 0,
                      background:
                        'linear-gradient( 90deg,  transparent, rgba(255, 255, 255, 0.8), transparent)',
                    },
                    '&:after': {
                      // content: '',
                      position: 'absolute',
                      top: 0,
                      height: '100%',
                      background:
                        'linear-gradient( 180deg,  transparent, rgba(255, 255, 255, 0.8), transparent, rgba(255, 255, 255, 0.3))',
                    },
                  }}
                >
                  <Box
                    sx={{
                      p: 2,
                      display: 'flex',
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      justifyContent: 'center',
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/accurate-records-icon.webp" />
                      <source srcSet="/assets/images/accurate-records-icon.png" />
                      <img
                        src="/assets/images/accurate-records-icon.png"
                        alt="Maintain Accurate Records"
                        // className="img-responsive"
                        loading="lazy"
                        width={50}
                        height={50}
                      />
                    </picture>
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 600,
                        fontSize: { lg: 16, md: 15 },
                        alignContent: 'center',
                        textAlign: 'center',
                      }}
                    >
                      Accurate Records
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    position: 'absolute',
                    width: { lg: 240, md: 240, sm: 180 },
                    alignSelf: 'center',

                    height: 80,
                    background: 'rgba(255, 255, 255, 0.06)',
                    backdropFilter: 'blur(16px)',
                    borderRadius: 4,
                    boxShadow:
                      '0 8px 32px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.5), inset 0 -1px 0 rgba(255, 255, 255, 0.1), inset 0 0 0px 0px rgba(255, 255, 255, 0)',
                    overflow: 'hidden',
                    bottom: { lg: 160, md: 0 },
                    right: { lg: 390, md: 270 },

                    '&:before': {
                      // content: '',
                      position: 'absolute',
                      top: 0,
                      background:
                        'linear-gradient( 90deg,  transparent, rgba(255, 255, 255, 0.8), transparent)',
                    },
                    '&:after': {
                      // content: '',
                      position: 'absolute',
                      top: 0,
                      height: '100%',
                      background:
                        'linear-gradient( 180deg,  transparent, rgba(255, 255, 255, 0.8), transparent, rgba(255, 255, 255, 0.3))',
                    },
                  }}
                >
                  <Box
                    sx={{
                      p: 2,
                      display: 'flex',
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      justifyContent: 'center',
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/build-trust-icon.webp" />
                      <source srcSet="/assets/images/build-trust-icon.png" />
                      <img
                        src="/assets/images/build-trust-icon.png"
                        alt="Build Trust & Credibility"
                        // className="img-responsive"
                        loading="lazy"
                        width={50}
                        height={50}
                      />
                    </picture>
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 600,
                        fontSize: { lg: 16, md: 15 },
                        alignContent: 'center',
                        textAlign: 'left',
                      }}
                    >
                      Build Trust & Credibility
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    position: 'absolute',
                    width: { lg: 240, md: 200 },
                    alignSelf: 'center',

                    height: 80,
                    background: 'rgba(255, 255, 255, 0.06)',
                    backdropFilter: 'blur(16px)',
                    borderRadius: 4,
                    boxShadow:
                      '0 8px 32px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.5), inset 0 -1px 0 rgba(255, 255, 255, 0.1), inset 0 0 0px 0px rgba(255, 255, 255, 0)',
                    overflow: 'hidden',
                    top: { lg: 150, md: 300 },
                    left: { lg: 350, md: 370 },

                    '&:before': {
                      // content: '',
                      position: 'absolute',
                      top: 0,
                      background:
                        'linear-gradient( 90deg,  transparent, rgba(255, 255, 255, 0.8), transparent)',
                    },
                    '&:after': {
                      // content: '',
                      position: 'absolute',
                      top: 0,
                      height: '100%',
                      background:
                        'linear-gradient( 180deg,  transparent, rgba(255, 255, 255, 0.8), transparent, rgba(255, 255, 255, 0.3))',
                    },
                  }}
                >
                  <Box
                    sx={{
                      p: 2,
                      display: 'flex',
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      justifyContent: 'center',
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/audit-risks-icon.webp" />
                      <source srcSet="/assets/images/audit-risks-icon.png" />
                      <img
                        src="/assets/images/audit-risks-icon.png"
                        alt="Audit Risks"
                        // className="img-responsive"
                        loading="lazy"
                        width={60}
                        height={60}
                      />
                    </picture>
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 16, sm: 17, xs: 16 },
                        alignContent: 'center',
                        textAlign: 'left',
                      }}
                    >
                      Reduce Audit Risks
                    </Typography>
                  </Box>
                </Box>
              </Hidden> */}
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 0,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                How to E-File Form 1098 series forms using TaxZerone?
              </Typography>
              <Typography
                variant="body1"
                sx={{ mt: 2, mb: 0, fontSize: { md: 18, sm: 16, xs: 16 } }}
              >
                E-File your 1098 Forms in 3 Simple Steps
              </Typography>
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth="xl" sx={{ mb: 5 }}>
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 2, md: 5 }}
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                width: '100%',
                mt: { xs: -3, md: -5, lg: -8 },
              }}
            >
              <picture>
                <source
                  srcSet="/assets/images/1098-steps-img.webp"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <source
                  srcSet="/assets/images/1098-steps-img.png"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <img
                  src="/assets/images/1098-steps-img.png"
                  alt="How to E-File Form 1098 series forms using TaxZerone?"
                  className="img-responsive"
                  loading="lazy"
                  width={915}
                  height={790}
                />
              </picture>
            </Box>

            <Box
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                m: '0',
                textAlign: { xs: 'center', md: 'left' },
              }}
            >
              {/* <Typography
                variant="h3"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  fontWeight: 600,
                  my: 3,
                }}
              >
                How it works:
              </Typography> */}
              <Box>
                <Box
                  component="ol"
                  sx={{
                    [`& .${timelineItemClasses.root}:before`]: {
                      flex: 0,
                      padding: 0,
                    },
                    p: 2,
                    pl: 0,
                    ml: { xs: 0, sm: 0, md: -2 },
                  }}
                >
                  <TimelineItem>
                    <TimelineSeparator>
                      <TimelineDot
                        sx={{
                          backgroundColor: 'transparent',
                          boxShadow: 'none',
                          my: -1,
                          mb: -1.7,
                        }}
                      >
                        <picture>
                          <source
                            srcSet="/assets/images/step-1-icon.webp"
                            width={39}
                            height={39}
                          />
                          <source
                            srcSet="/assets/images/step-1-icon.png"
                            width={39}
                            height={39}
                          />
                          <img
                            src="/assets/images/step-1-icon.png"
                            alt="Choose Your Form"
                            loading="lazy"
                            width={39}
                            height={39}
                          />
                        </picture>
                      </TimelineDot>
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent sx={{ mb: 2 }}>
                      <Typography variant="body1">
                        <b>Choose Your Form </b> <br />
                        Select the applicable form and enter all the required
                        details
                      </Typography>
                    </TimelineContent>
                  </TimelineItem>
                  <TimelineItem>
                    <TimelineSeparator>
                      <TimelineDot
                        sx={{
                          backgroundColor: 'transparent',
                          boxShadow: 'none',
                          m: 0,
                          mt: -1,
                          mb: -1.7,
                        }}
                      >
                        <picture>
                          <source srcSet="/assets/images/step-2-icon.webp" />
                          <source srcSet="/assets/images/step-2-icon.png" />
                          <img
                            src="/assets/images/step-2-icon.png"
                            alt="Transmit to the IRS"
                            loading="lazy"
                            width={39}
                            height={39}
                          />
                        </picture>
                      </TimelineDot>
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent sx={{ mb: 2 }}>
                      <Typography variant="body1">
                        <b>Transmit to the IRS </b> <br />
                        Our built-in error checks ensure accuracy before
                        securely transmitting your form to the IRS.
                      </Typography>
                    </TimelineContent>
                  </TimelineItem>
                  <TimelineItem>
                    <TimelineSeparator>
                      <TimelineDot
                        sx={{
                          backgroundColor: 'transparent',
                          boxShadow: 'none',
                          mt: -1,
                          mb: -1.7,
                        }}
                      >
                        <picture>
                          <source srcSet="/assets/images/step-3-icon.webp" />
                          <source srcSet="/assets/images/step-3-icon.png" />
                          <img
                            src="/assets/images/step-3-icon.png"
                            alt="Send Recipient’s Copy"
                            loading="lazy"
                            width={39}
                            height={39}
                          />
                        </picture>
                      </TimelineDot>
                    </TimelineSeparator>
                    <TimelineContent>
                      <Typography variant="body1">
                        <b>Deliver Recipient Copies </b> <br />
                        Deliver your recipient copies via ZeroneVault or Postal
                        Mailing.
                      </Typography>
                    </TimelineContent>
                  </TimelineItem>
                </Box>
                <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                  <Button
                    variant="contained"
                    sx={{
                      mt: { xs: 2, sm: 4 },
                      mb: { xs: 2, sm: 2, md: 5 },
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    className="btn-primary"
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=f1098series`}
                  >
                    E-File Now
                  </Button>
                </Box>
              </Box>
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        className="dotted-curve"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Benefits of E-Filing the Form 1098 Series with TaxZerone
              </Typography>
              {/* <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                TaxZerone simplifies information return filing with these
                amazing features
              </Typography> */}
            </Grid>
          </Grid>

          <Grid container spacing={2} m={2} mt={4} pb={{ xs: 0, sm: 4, md: 7 }}>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/easy-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/easy-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/easy-icon.png"
                      alt="Easy Filing "
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Easy Filing
                </Typography>
                <Typography variant="body1">
                  With TaxZerone’s step-by-step instructions, you will be guided
                  clearly through the entire process from entering your
                  information to transmitting return to the IRS.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/upload-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/upload-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/upload-icon.png"
                      alt="Bulk Upload "
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Bulk Upload
                </Typography>
                <Typography variant="body1">
                  Struggling with filing multiple forms? No worries –
                  TaxZerone&apos;s Bulk upload feature will help you to file
                  multiple forms at once.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/zeronevault-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/zeronevault-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/zeronevault-icon.png"
                      alt="ZeroneVault"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  ZeroneVault
                </Typography>
                <Typography variant="body1">
                  Deliver your recipient’s copy instantly with ZeroneVault – a
                  secure way to send the copy of the form.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={12}>&nbsp;</Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',

                  borderColor: '#76ce97',
                  borderRadius: 10,
                  // mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/irs-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/irs-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/irs-icon.png"
                      alt="IRIS Support "
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  IRIS Support
                </Typography>
                <Typography variant="body1">
                  TaxZerone supports{' '}
                  <span style={{ fontWeight: 600 }}> IRIS</span> (Information
                  Returns Intake System) for all electronic filing of
                  information return.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',

                  borderColor: '#8492c0',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/real-time-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/real-time-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/real-time-icon.png"
                      alt="Real-Time Updates"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Real-Time Updates
                </Typography>
                <Typography variant="body1">
                  Stay informed at every step of your Form 1098 filing with
                  TaxZerone, from submission to IRS acceptance, through timely
                  email notifications sent directly to your inbox.
                </Typography>
              </Paper>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  // mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/form-based-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/form-based-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/form-based-icon.png"
                      alt="Schedule Filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Schedule Filing
                </Typography>
                <Typography variant="body1">
                  With our{' '}
                  <span style={{ fontWeight: 600 }}> schedule filing</span>{' '}
                  feature, you can prepare the returns ahead of time and choose
                  the exact date you want them submit to the IRS.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={12}>&nbsp;</Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',

                  borderColor: '#8492c0',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/lowest-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/lowest-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/lowest-icon.png"
                      alt="Affordable Pricing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Affordable Pricing
                </Typography>
                <Typography variant="body1">
                  TaxZerone offers an affordable price in the industry, making
                  reliable and IRS-compliant e-filing accessible for everyone.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',

                  borderColor: '#76ce97',
                  borderRadius: 10,
                  // mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/form-access-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/form-access-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/form-access-icon.png"
                      alt="Smart Validations"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Smart Validations
                </Typography>
                <Typography variant="body1">
                  Our smart system validates your forms for any errors before
                  sending them to the IRS, so you can file with confidence.
                </Typography>
              </Paper>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/support-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/support-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/support-icon.png"
                      alt="Expert Support"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Expert Support
                </Typography>
                <Typography variant="body1">
                  Stuck with filing-related Queries? Our expert support team is
                  there to guide you via Email, Phone (English & Spanish), and
                  live chat.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Container maxWidth="lg" sx={{ px: { xs: 0, sm: 2 } }}>
        <Grid
          container
          spacing={2}
          m={2}
          mt={{ xs: 5, sm: 5, md: 10 }}
          mb={{ xs: 5, sm: 5, md: 10 }}
          className="MuiGrid-root-width"
        >
          <Grid size={12} textAlign="center">
            <Stack
              direction="row"
              spacing={1}
              sx={{ mb: 2 }}
              justifyContent={{ xs: 'center', md: 'center' }}
            >
              <img
                src="/assets/images/star-icon.svg"
                width={30}
                height={28}
                alt="star-1"
              />
              <img
                src="/assets/images/star-icon.svg"
                width={30}
                height={28}
                alt="star-2"
              />
              <img
                src="/assets/images/star-icon.svg"
                width={30}
                height={28}
                alt="star-3"
              />
              <img
                src="/assets/images/star-icon.svg"
                width={30}
                height={28}
                alt="star-4"
              />
              <img
                src="/assets/images/star-icon.svg"
                width={30}
                height={28}
                alt="star-5"
              />
            </Stack>
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: { xs: 1, sm: 3 },
              }}
            >
              Hear What Our Clients Say About Us
            </Typography>

            <Carousel
              animation="fade"
              navButtonsAlwaysVisible
              indicatorIconButtonProps={{
                style: {
                  marginTop: '0px', // 5
                  textAlign: 'right', // 4
                  paddingBottom: '0px',
                  marginBottom: '0px',
                },
              }}
              className="carousel"
            >
              {images.map((step, index) => (
                <Box
                  component="div"
                  sx={{
                    p: 2,
                    textAlign: 'center',

                    borderRadius: 0,
                    backgroundColor: 'transparent',
                    borderWidth: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    alignItems: 'flex-start',
                    mx: { xs: -2, sm: 'auto' },
                    maxWidth: 800,
                    minHeight: { xs: 200, sm: 170, md: 220 },
                  }}
                  key={index}
                >
                  <Typography
                    component="span"
                    sx={{
                      fontFamily: 'san-serif',
                      fontSize: { xs: 65, sm: 100 },
                      fontWeight: 600,
                      color: '#1da94a',
                      lineHeight: { xs: '30px', sm: '65px' },
                    }}
                  >
                    &ldquo;
                  </Typography>
                  <Typography
                    variant="body1"
                    component="div"
                    color="gray"
                    sx={{
                      fontSize: { xs: 18, sm: 22, md: 30 },
                      fontFamily: 'san-serif',
                      fontStyle: 'italic',
                      color: '#414042',
                      lineHeight: 1.2,
                    }}
                  >
                    {step.label}
                  </Typography>
                  <Typography
                    component="span"
                    sx={{
                      fontFamily: 'san-serif',
                      fontSize: { xs: 65, sm: 100 },
                      fontWeight: 600,
                      color: '#1da94a',
                      lineHeight: { xs: '30px', sm: '65px' },
                    }}
                  >
                    &rdquo;
                  </Typography>
                </Box>
              ))}
            </Carousel>
          </Grid>
        </Grid>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction={{ xs: 'column-reverse', sm: 'row' }}
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12} sx={{ justifyContent: 'center' }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Common Use Cases
              </Typography>
              <Box
                sx={{
                  alignItems: 'center',
                  justifyContent: 'center',
                  alignContent: 'center',
                  m: 'auto',
                  display: 'flex',
                }}
              >
                <picture>
                  <source srcSet="/assets/images/f1098s-use-case-img.webp" />
                  <source srcSet="/assets/images/f1098s-use-case-img.png" />
                  <img
                    src="/assets/images/f1098s-use-case-img.png"
                    alt="Common Use Cases"
                    className="responsive-img"
                    loading="lazy"
                    width={1001}
                    height="auto"
                    style={{
                      // border: '1px solid rgba(190, 190, 190, 0.3)',
                      borderRadius: 6,
                      aspectRatio: 'auto 480 / 296',
                    }}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Competitor Comparison: Why Choose TaxZerone
                <Hidden smDown>
                  {' '}
                  <br />
                </Hidden>
                for 1098 Series E-Filing
              </Typography>
              <Box component="div" sx={{ mb: 3, backgroundColor: '#fff' }}>
                <TableContainer sx={{}}>
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          sx={{
                            color: '#444',
                            width: 200,
                            fontWeight: 600,
                            fontSize: 16,
                          }}
                        >
                          Feature
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#444',
                            width: 200,
                            fontWeight: 600,
                            fontSize: 16,
                            textAlign: 'left',
                          }}
                        >
                          TaxZerone
                        </TableCell>
                        <TableCell
                          sx={{
                            color: '#444',
                            width: 200,
                            fontWeight: 600,
                            fontSize: 16,
                            textAlign: 'left',
                          }}
                        >
                          Other E-file Platforms
                        </TableCell>
                        <TableCell
                          sx={{
                            color: '#444',
                            width: 200,
                            fontWeight: 600,
                            fontSize: 16,
                            textAlign: 'left',
                          }}
                        >
                          Paper Filing (Manual)
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow sx={{}}>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #b2b2b2a6',
                            fontSize: 15,
                            fontWeight: 600,
                          }}
                        >
                          IRS-Authorized E-File Provider
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          <DoneIcon
                            sx={{ color: '#1da94a', fontSize: 30, mb: -1 }}
                          />{' '}
                          Yes{' '}
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          {' '}
                          <DoneIcon
                            sx={{ color: '#1da94a', fontSize: 30, mb: -1 }}
                          />{' '}
                          Varies
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          No
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #b2b2b2a6',
                            fontSize: 15,
                            fontWeight: 600,
                          }}
                        >
                          Form Coverage
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          Supports all 1098 series (1098, <br />
                          1098-C, 1098-E, 1098-F, 1098-T, 1098-Q)
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          {' '}
                          Limited coverage (not all forms supported)
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Not Applicable
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{}}>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #b2b2b2a6',
                            fontSize: 15,
                            fontWeight: 600,
                          }}
                        >
                          Pricing
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          As low as{' '}
                          <span style={{ fontWeight: 600, fontSize: 15 }}>
                            $0.59 per form
                          </span>{' '}
                          <br />
                          (for 1000+)
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          {' '}
                          Higher filing fees, hidden charges
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          Printing, postage & manual costs
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #b2b2b2a6',
                            fontSize: 15,
                            fontWeight: 600,
                          }}
                        >
                          Real-Time Error Validation
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                            display: 'flex',
                          }}
                        >
                          <DoneIcon
                            sx={{
                              color: '#1da94a',
                              fontSize: 30,
                              mb: -1,
                              mr: 0.5,
                            }}
                          />{' '}
                          <Box>Automatic validation before IRS submission</Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          {' '}
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Limited checks
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Manual review only
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{}}>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #b2b2b2a6',
                            fontSize: 15,
                            fontWeight: 600,
                          }}
                        >
                          Bulk Upload
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          {' '}
                          <DoneIcon
                            sx={{
                              color: '#1da94a',
                              fontSize: 30,
                              mb: -1,
                              mr: 0.5,
                            }}
                          />{' '}
                          Accepts extension files
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          {' '}
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Limited or unavailable
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Not possible
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #b2b2b2a6',
                            fontSize: 15,
                            fontWeight: 600,
                          }}
                        >
                          Corrections & Re-file
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                            display: 'flex',
                          }}
                        >
                          <DoneIcon
                            sx={{
                              color: '#1da94a',
                              fontSize: 30,
                              mb: -1,
                              mr: 0.5,
                            }}
                          />{' '}
                          <Box>Free corrections for rejected returns</Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          {' '}
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Extra charges
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                            display: 'flex',
                          }}
                        >
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          <Box>Manual corrections, resubmission delays</Box>
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{}}>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #b2b2b2a6',
                            fontSize: 15,
                            fontWeight: 600,
                          }}
                        >
                          Delivery Options
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          <DoneIcon
                            sx={{ color: '#1da94a', fontSize: 30, mb: -1 }}
                          />{' '}
                          E-delivery & Postal Mailing
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          {' '}
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Limited
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Manual printing & mailing
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #b2b2b2a6',
                            fontSize: 15,
                            fontWeight: 600,
                          }}
                        >
                          Recipient Access Portal
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                            display: 'flex',
                          }}
                        >
                          <DoneIcon
                            sx={{
                              color: '#1da94a',
                              fontSize: 30,
                              mb: -1,
                              mr: 0.5,
                            }}
                          />{' '}
                          <Box>
                            <Link
                              href="https://www.zeronevault.com/"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              ZeroneVault
                            </Link>{' '}
                            (Secure & <br />
                            IRS-compliant portal)
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          {' '}
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Not available
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Not available
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{}}>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #b2b2b2a6',
                            fontSize: 15,
                            fontWeight: 600,
                          }}
                        >
                          Filing Scheduler
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          <DoneIcon
                            sx={{ color: '#1da94a', fontSize: 30, mb: -1 }}
                          />{' '}
                          Schedule filings in advance
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          {' '}
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Limited
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Not possible
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #b2b2b2a6',
                            fontSize: 15,
                            fontWeight: 600,
                          }}
                        >
                          Reminders
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                            display: 'flex',
                          }}
                        >
                          <DoneIcon
                            sx={{
                              color: '#1da94a',
                              fontSize: 30,
                              mb: -1,
                              mr: 0.5,
                            }}
                          />{' '}
                          <Box>Email reminders sent before IRS deadlines</Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          {' '}
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Not available
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Not available
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{}}>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #b2b2b2a6',
                            fontSize: 15,
                            fontWeight: 600,
                          }}
                        >
                          Customer Support
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          U.S. based support
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          {' '}
                          Limited or email-only
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          None
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            lineHeight: 1.5,
            mb: 3,
          }}
        >
          Ready to E-File your 1098 forms?
        </Typography>
        <Typography
          variant="body1"
          color="white"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            mb: 2,
          }}
        >
          E-file your Form 1098 series with TaxZerone today!
          <Hidden smDown>
            <br />
          </Hidden>{' '}
          We makes electronic filing simple, secure, and affordable.
        </Typography>

        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=f1098series`}
          >
            E-File Now
          </Button>
        </Box>
      </Box>

      <Container maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, md: 9, sm: 10 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. What is the Form 1098 series used for?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    The 1098 series is a group of IRS information returns used
                    to report various types of payments or contributions made by
                    individuals or organizations, mainly for tax deduction or
                    credit purposes.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. Which forms are included in the Form 1098 series at
                  TaxZerone?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      The forms included in the 1098 series is
                    </Typography>
                    <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                      <li>
                        {' '}
                        <Link
                          href="/information-returns/efile-irs-form-1098/"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form 1098
                        </Link>{' '}
                        - Mortgage Interest Statement{' '}
                      </li>

                      <li>
                        {' '}
                        <Link
                          href="/information-returns/efile-irs-form-1098-c/"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form 1098-C
                        </Link>{' '}
                        - Contributions of Motor Vehicles, Boats, and
                        Airplanes{' '}
                      </li>

                      <li>
                        {' '}
                        <Link
                          href="/information-returns/efile-irs-form-1098-e/"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form 1098-E
                        </Link>{' '}
                        - Student Loan Interest Statement{' '}
                      </li>
                      <li>
                        {' '}
                        <Link
                          href="/information-returns/efile-irs-form-1098-f/"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form 1098-F
                        </Link>{' '}
                        - Fines, Penalties, and Other Amounts{' '}
                      </li>
                      <li>
                        {' '}
                        <Link
                          href="/information-returns/efile-irs-form-1098-t/"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form 1098-T
                        </Link>{' '}
                        - Tuition Statement{' '}
                      </li>
                      <li>
                        {' '}
                        <Link
                          href="/information-returns/efile-irs-form-1098-q/"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form 1098-Q
                        </Link>{' '}
                        - Qualifying Longevity Annuity Contract Information{' '}
                      </li>
                    </Box>
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. Do I need to file 1098 forms electronically?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    <span style={{ fontWeight: 600 }}> Yes,</span> if you are
                    filing <span style={{ fontWeight: 600 }}>10 or more</span>{' '}
                    of 1098 forms, the IRS mandates electronic filing. TaxZerone
                    makes your e-filing simple, secure, and affordable.
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid size={12} sx={{ borderTop: '1px solid #ccc' }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 3,
                mt: 1,
                textAlign: 'center',
              }}
            >
              New here?
            </Typography>
            <Typography
              variant="h3"
              sx={{
                fontSize: { lg: 22, md: 20, sm: 18, xs: 18 },
                fontWeight: 600,
                mb: 3,
                mt: 1,
                textAlign: 'center',
              }}
            >
              Get the support you need.
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, md: 4, sm: 6 }}>
            <Link href="/resources/" sx={{ textDecoration: 'none' }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 5,
                  height: '100%',
                  backgroundColor: '#f0f2f9',
                  '&:hover': {
                    cursor: 'pointer',
                    boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
                  },
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                    textAlign: 'center',
                  }}
                >
                  Resources
                </Typography>
                <Typography variant="body1">
                  Find everything you need in one place — from how-to guides to
                  quick tips that simplify your tax filing journey.
                </Typography>
              </Paper>
            </Link>
          </Grid>
          <Grid size={{ xs: 12, md: 4, sm: 6 }}>
            <Link
              href="https://blog.taxzerone.com/"
              target="_blank"
              sx={{ textDecoration: 'none' }}
            >
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 5,
                  height: '100%',
                  backgroundColor: '#f0f2f9',
                  '&:hover': {
                    cursor: 'pointer',
                    boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
                  },
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                    textAlign: 'center',
                  }}
                >
                  Blogs
                </Typography>
                <Typography variant="body1">
                  Read our latest articles packed with IRS updates, tax-saving
                  tips, and filing hacks to keep you ahead.
                </Typography>
              </Paper>
            </Link>
          </Grid>
          <Grid size={{ xs: 12, md: 4, sm: 6 }}>
            <Link
              href="https://support.taxzerone.com/"
              target="_blank"
              sx={{ textDecoration: 'none' }}
            >
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 5,
                  height: '100%',
                  backgroundColor: '#f0f2f9',
                  '&:hover': {
                    cursor: 'pointer',
                    boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
                  },
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                    textAlign: 'center',
                  }}
                >
                  Support Article
                </Typography>
                <Typography variant="body1">
                  Not sure where to begin? Our Support articles will guide you
                  through the 1098 forms filing process with clear answers.
                </Typography>
              </Paper>
            </Link>
          </Grid>
          <Grid size={12} sx={{ mt: 6, borderTop: '1px solid #ccc' }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 1,
                mt: 3,
                textAlign: 'center',
              }}
            >
              Still have questions about 1098 forms?
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                fontWeight: 400,
                mb: 3,
                mt: 1,
                textAlign: 'center',
              }}
            >
              Reach out to our friendly support team for all your Queries.
            </Typography>
          </Grid>
          <Grid
            size={{ xs: 12, md: 4, sm: 6 }}
            sx={{
              mb: 0,
              '& :hover': {
                color: '#0202ff',
              },
            }}
          >
            <Link href="mailto:support@taxzerone.com" underline="none">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 5,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  backgroundColor: '#f0f2f9',
                  '&:hover': {
                    cursor: 'pointer',
                    boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
                  },
                }}
              >
                <Box>
                  <picture>
                    <source
                      srcSet="/assets/images/email-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/email-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/email-icon.png"
                      alt="Email Support"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                    textAlign: 'center',
                  }}
                >
                  support@taxzerone.com
                </Typography>
              </Paper>
            </Link>
          </Grid>
          <Grid
            size={{ xs: 12, md: 4, sm: 6 }}
            sx={{
              mb: 0,
              '& :hover': {
                color: '#0202ff',
              },
            }}
          >
            <Link href="tel:+14084447120" underline="none">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 5,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  backgroundColor: '#f0f2f9',
                  '&:hover': {
                    cursor: 'pointer',
                    boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
                  },
                }}
              >
                <Box>
                  <picture>
                    <source
                      srcSet="/assets/images/support-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/support-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/support-icon.png"
                      alt="Email Support"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                    textAlign: 'center',
                  }}
                >
                  (408) 444-7120
                </Typography>
              </Paper>
            </Link>
          </Grid>
          <Grid
            size={{ xs: 12, md: 4, sm: 6 }}
            sx={{
              mb: 0,
              '& :hover': {
                color: '#0202ff',
              },
            }}
          >
            <Paper
              variant="outlined"
              sx={{
                p: 3,
                py: 3,
                textAlign: 'center',
                borderWidth: 2,
                borderColor: 'transparent',
                borderRadius: 5,
                height: '100%',
                transition: 'all 0.3s ease 0s',
                backgroundColor: '#f0f2f9',
                // '&:hover': {
                //   cursor: 'pointer',
                //   boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
                // },
              }}
            >
              <Box>
                <picture>
                  <source
                    srcSet="/assets/images/chat-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/chat-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/chat-icon.png"
                    alt="Email Support"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>
              </Box>
              <Typography
                variant="h3"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  fontWeight: 600,
                  my: 3,
                  textAlign: 'center',
                }}
              >
                Chat Support
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default Form1098Series;
